import { cleanUrlSearch } from '../utils';
import React from 'react';
import { useLocation, useNavigate } from 'react-router';

/**
 * Hook that removes tracking parameters from the URL.
 * It replaces the current URL in history with a clean version,
 * without causing a page reload.
 */
export const useCleanTrackingParams = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!search) return;

    const cleanSearch = cleanUrlSearch(search);

    // If the search string changed (tracking params were removed), update URL
    if (cleanSearch !== search) {
      const cleanPath = `${pathname}${cleanSearch}${hash}`;
      // Replace current history entry with clean URL
      navigate(cleanPath, { replace: true });
    }
  }, [pathname, search, hash, navigate]);
};

export default useCleanTrackingParams;
